import { render, staticRenderFns } from "./ProgressProposals.vue?vue&type=template&id=0a36d148&scoped=true&"
import script from "./ProgressProposals.vue?vue&type=script&lang=js&"
export * from "./ProgressProposals.vue?vue&type=script&lang=js&"
import style0 from "./ProgressProposals.vue?vue&type=style&index=0&id=0a36d148&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36d148",
  null
  
)

export default component.exports